export default "__VITE_ASSET__C0w72wQj__"